import type { AxiosError, AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getContentTypesBuilder(apiClient: AxiosInstance) {
  return async function getContentTypes(
    page: number,
    searchTerm?: string,
  ): Promise<{
    count: number;
    results: IContent.ContentType[];
    previous?: string;
    next?: string;
  }> {
    try {
      const response = await apiClient.get(`/v2/pages/`, {
        params: {
          search: searchTerm,
          page,
        },
      });

      return response.data;
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
